import {
  Directive,
  ElementRef,
  inject,
  input,
  InputSignal
} from '@angular/core';
import { KeyCode } from '../../domain/key-code.enum';
import { OpenWindowService } from './open-window.service';

import type { LinkParameters } from '../../services/link-registry.service';
import type { ExportRequest } from '../../services/export/export.domain';

export type OpenWindowParameters = LinkParameters | ExportRequest;

@Directive({
  selector: '[tdWbOpenWindow]',
  exportAs: 'tdWbOpenWindow',
  host: {
    '(click)': 'open($event)',
    '(keydown)': 'onKeyDown($event, $event.key)'
  }
})
export class OpenWindowDirective {
  url: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'tdWbOpenWindow' });
  parameters: InputSignal<OpenWindowParameters | undefined> = input<OpenWindowParameters | undefined>(undefined, { alias: 'tdWbOpenWindowParameters' });
  name: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'tdWbOpenWindowName' });
  features: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'tdWbOpenWindowFeatures' });

  private openWindowService: OpenWindowService = inject(OpenWindowService);
  private elementRef: ElementRef = inject(ElementRef);
  private get role(): string | null {
    return this.elementRef.nativeElement.getAttribute('role');
  }

  open(event?: MouseEvent | KeyboardEvent): void {
    if (event !== undefined) {
      event.preventDefault();
    }
    this.openWindowService.open(this.url(), this.parameters(), this.name(), this.features());
  }

  onKeyDown(event: KeyboardEvent, keyCode: string): void {
    if ((this.role === 'button' && (keyCode === KeyCode.ENTER || keyCode === KeyCode.SPACE)) ||
      (this.role === 'link' && keyCode === KeyCode.ENTER)) {
      this.open(event);
    }
  }
}
